export const CATEGORIES = {
  formazione_generale: { label: "Formazione Generale", color: "#2FA84F" },
  formazione_specifica: { label: "Formazione Specifica", color: "#003366" },
  primo_soccorso: { label: "Primo Soccorso", color: "#F97316" },
  antincendio: { label: "Antincendio", color: "#EF4444" },
  rspp: { label: "RSPP", color: "#8B5CF6" },
  rls: { label: "RLS", color: "#EAB308" },
  attrezzature: { label: "Attrezzature", color: "#111827" },
  haccp: { label: "HACCP", color: "#A16207" },
};

export const STATUS = {
  available: { label: "Posti disponibili", color: "#2FA84F", bg: "rgba(47,168,79,0.10)" },
  last: { label: "Ultimi posti", color: "#F97316", bg: "rgba(249,115,22,0.10)" },
  full: { label: "Completo", color: "#EF4444", bg: "rgba(239,68,68,0.10)" },
};

export const TYPE_LABEL = {
  full: "Corso completo",
  refresh: "Aggiornamento",
};

export const MONTHS_IT = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export function formatDateIT(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return `${d} ${MONTHS_IT[m - 1]} ${y}`;
}

export function formatDatesIT(dates) {
  if (!dates || dates.length === 0) return "Su richiesta";
  if (dates.length === 1) return formatDateIT(dates[0]);
  return dates.map((iso) => {
    const [, m, d] = iso.split("-").map(Number);
    return `${d} ${MONTHS_IT[m - 1].slice(0, 3)}`;
  }).join(" · ");
}

export const WEEKDAYS_FULL = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];

export function formatDateLongIT(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  const wd = new Date(y, m - 1, d).getDay();
  return `${WEEKDAYS_FULL[wd]} ${d} ${MONTHS_IT[m - 1]} ${y}`;
}

export function giornataSchedule(g) {
  if (!g) return "";
  const parts = [];
  if (g.start || g.end) parts.push(`${g.start || ""} - ${g.end || ""}`.trim());
  if (g.start2 || g.end2) parts.push(`${g.start2 || ""} - ${g.end2 || ""}`.trim());
  return parts.filter(Boolean).join(" / ");
}
